import React, { cloneElement } from 'react';
import { BookOpen, MonitorPlay, Users, FileText, ClipboardCheck, Calendar, Image as ImageIcon, BarChart, Layers, Link, TrendingUp, Brain, Cpu, FileSearch } from 'lucide-react';
export function WhatsIncluded() {
  const features = [{
    icon: <BookOpen size={32} data-id="element-188" />,
    text: 'Manuales completos de Programación I, II, III y IV'
  }, {
    icon: <TrendingUp size={32} data-id="element-189" />,
    text: 'Progresión pedagógica clara'
  }, {
    icon: <MonitorPlay size={32} data-id="element-190" />,
    text: 'Clases desarrolladas'
  }, {
    icon: <ImageIcon size={32} data-id="element-191" />,
    text: 'Diapositivas listas para proyectar'
  }, {
    icon: <Users size={32} data-id="element-192" />,
    text: 'Actividades y juegos interactivos'
  }, {
    icon: <FileText size={32} data-id="element-193" />,
    text: 'Trabajos prácticos completos'
  }, {
    icon: <ClipboardCheck size={32} data-id="element-194" />,
    text: 'Evaluaciones listas para utilizar'
  }, {
    icon: <Calendar size={32} data-id="element-195" />,
    text: 'Planificaciones organizadas'
  }, {
    icon: <Brain size={32} data-id="element-196" />,
    text: 'Ejemplos explicados paso a paso'
  }, {
    icon: <BarChart size={32} data-id="element-197" />,
    text: 'Diagramas y recursos visuales'
  }, {
    icon: <FileSearch size={32} data-id="element-198" />,
    text: 'Contenido teórico resumido y simplificado'
  }, {
    icon: <Link size={32} data-id="element-199" />,
    text: 'Conceptos desarrollados con lenguaje claro'
  }, {
    icon: <Layers size={32} data-id="element-200" />,
    text: 'Contenido bien estructurado'
  }];
  return <section className="py-8 md:py-16 px-4 bg-dark-800 border-y border-dark-700" data-id="element-201">
      <div className="max-w-6xl mx-auto" data-id="element-202">
        <div className="text-center mb-8 md:mb-12" data-id="element-203">
          <h2 className="text-2xl md:text-5xl font-black text-white mb-3 md:mb-4 uppercase" data-id="element-204">
            📘 ¿QUÉ INCLUYE EL <span className="text-brand-400" data-id="element-205">SISTEMA?</span>
          </h2>
          <p className="text-base md:text-xl text-gray-400 font-medium max-w-2xl mx-auto" data-id="element-206">
            Accedé al sistema académico completo que organiza TODO tu trabajo
            docente en un solo lugar.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-6" data-id="element-207">
          {features.map((feature, i) => <div key={i} className="bg-dark-900 p-4 md:p-6 rounded-xl shadow-md border border-dark-700 flex flex-col items-center text-center hover:-translate-y-1 hover:shadow-lg hover:border-brand-500/50 transition-all duration-300" data-id="element-208">
              <div className="bg-brand-500/10 text-brand-400 p-3 md:p-4 rounded-full mb-3 md:mb-4" data-id="element-209">
                {cloneElement(feature.icon, {
              className: 'w-6 h-6 md:w-8 md:h-8'
            })}
              </div>
              <h3 className="font-bold text-sm md:text-lg text-gray-200 leading-tight" data-id="element-210">
                {feature.text}
              </h3>
            </div>)}
        </div>
      </div>
    </section>;
}